import { c as _c } from "react/compiler-runtime";
import { classNames } from "@opensea/ui-kit";
import { useTranslations } from "use-intl";
import { Button } from "../Button";
export const PasteFromClipboardButton = t0 => {
  const $ = _c(10);
  const {
    onPaste,
    className
  } = t0;
  const t = useTranslations("wallet.PasteFromClipboardButton");
  let t1;
  if ($[0] !== onPaste) {
    t1 = async () => {
      const text = await navigator.clipboard.readText();
      onPaste(text);
    };
    $[0] = onPaste;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const pasteFromClipboard = t1;
  let t2;
  if ($[2] !== className) {
    t2 = classNames("w-full", className);
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("paste");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== pasteFromClipboard || $[7] !== t2 || $[8] !== t3) {
    t4 = <Button className={t2} onClick={pasteFromClipboard} size="lg" variant="secondary">{t3}</Button>;
    $[6] = pasteFromClipboard;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};